import { render } from "./ComplianceCompany.vue?vue&type=template&id=21d41c34&scoped=true"
import script from "./ComplianceCompany.vue?vue&type=script&lang=js"
export * from "./ComplianceCompany.vue?vue&type=script&lang=js"

import "./custom-compliance.scss?vue&type=style&index=0&id=21d41c34&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d41c34"]])

export default __exports__